module.exports = __webpack_public_path__ + "img/icon_copy_primary.d508609e.svg";